export const profile = [];

export const ToastType = {
  Success: 'success',
  Error: 'danger',
  Info: 'info',
  Warning: 'warning',
};

export const IntentType = {
  Login: 'login',
  Register: 'register',
  Checkout: 'checkout',
};

// Set separate email fields for info and support, so if a new info email is added in the future it is easily updatable
export const ContactInfo = {
  InfoEmailAddress: 'support@sportpix.co.za',
  SupportEmailAddress: 'support@sportpix.co.za',
  InstagramHandle: 'https://www.instagram.com/sportpix.za/',
  FacebookPage: 'https://www.facebook.com/SportPixZA',
  Telephone: '+27311234567',
};

export const SiteInfo = {
  PrivacyPolicyEffectiveDate: '14 April 2025',
  PrivacyPolicyLastUpdated: '14 April 2025',
  TermsOfUseEffectiveDate: '15 April 2025',
  TermsOfUseLastUpdated: '15 April 2025',
};

export const ExternalLinks = {
  VISA: 'https://www.visa.co.za',
  SnapScan: 'https://www.snapscan.co.za',
  Zapper: 'https://www.zapper.com/',
  PayFast: 'https://payfast.io/',
  SiDSecureEFT: 'https://sidpayment.com/',
  Mastercard: 'https://www.mastercard.co.za/en-za.html',
  CreationLabs: 'https://creationlabs.co.za',
};

export const PhotoType = {
  Single: 'Single',
  Pack: 'Pack',
};

export const StyleType = {
  Event: 'Event',
  Plain: 'Plain',
  RaceTime: 'Race Time',
};

export const DeliveryType = {
  Digital: 'Digital',
  Print: 'Print',
};

export const DigitalSize = {
  Standard: 'Digital Standard',
  HighDefinition: 'Digital High Definition',
};

export const PrintSize = {
  Standard: 'Print Standard',
  Jumbo: 'Print Jumbo',
  A4: 'Print A4',
  A3: 'Print A3 Canvas',
};

export const provinces = [
  'Eastern Cape',
  'Free State',
  'Gauteng',
  'KwaZulu-Natal',
  'Limpopo',
  'Mpumalanga',
  'Northern Cape',
  'North West',
  'Western Cape',
];

export const OrderStatuses = [
  { label: 'Awaiting Payment', value: 'Awaiting Payment' },
  { label: 'Processing', value: 'Processing' },
  { label: 'Complete', value: 'Complete' },
];
